function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable no-self-compare */
import { isFunc } from '@@/utils/ObjUtils';
import React from 'react';
const Connect = Component => {
  return class ConnectClass extends React.Component {
    subscribe = Component.subscribe || [];
    constructor(props) {
      super(props);
      this.component = /*#__PURE__*/React.createRef();
      if (props.subscribe) {
        this.subscribe = Array.isArray(props.subscribe) ? props.subscribe : [props.subscribe];
      }
      this.subscribe.forEach(store => store.addChangeListener(this.handleChange));

      /**
       * There are some scenarios when a component may want to set the inital state of a store prior to the storeStateToProps
       * If you set this property on the component it will not run the storeStateToProps on initial mount
       **/
      if (Component.skipStoreStateToPropsOnMount) {
        this.state = {
          ...props
        };
        return;
      }
      ;
      const finalProps = this._mapStateToProps(props);
      this.state = finalProps;
    }
    _mapStateToProps(props) {
      const defaultProps = Component.defaultProps || {};
      const updates = {};
      const statesArray = this.subscribe.map(s => s.getState());
      let stateToProps = Component.storeStateToProps || this.component.current?.storeStateToProps;
      for (const prop in stateToProps) {
        if (!stateToProps.hasOwnProperty(prop)) continue;
        const result = stateToProps[prop]({
          ...defaultProps,
          ...props,
          ...updates
        }, ...statesArray);
        updates[prop] = result;
      }
      return mergeFinalProps(updates, props);
    }
    componentWillUnmount() {
      this.subscribe.forEach(store => store.removeChangeListener(this.handleChange));
    }
    handleChange = () => {
      //This is an indicator the child component is not mounted, do not try to set state
      if (!this.component.current) return;
      const finalProps = this._mapStateToProps(this.props);
      this.setState(finalProps);
    };
    shouldComponentUpdate(nextProps, nextState) {
      const parentUpdate = !shallowEqual(this.props, nextProps);
      if (parentUpdate || !shallowEqual(this.state, nextState)) {
        //Only do everything if the parent passed in new props
        if (parentUpdate) {
          let finalProps = this._mapStateToProps(nextProps);
          this.setState(finalProps);
          //this.forceUpdate();
          return false;
        }
        return true;
      }
      return false;
    }
    render() {
      return /*#__PURE__*/React.createElement(Component, _extends({}, this.state, {
        ref: this.component
      }));
    }
  };
};
const normalizeValue = obj => {
  //if(!obj.hasOwnProperty("value")) return obj;

  //if(obj.value=== undefined || obj.value === null) obj.value = "";

  return obj;
};
const hasOwn = Object.prototype.hasOwnProperty;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;
  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  for (let i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
function mergeFinalProps(stateProps = {}, ownProps = {}) {
  return normalizeValue({
    ...ownProps,
    ...stateProps
  });
}
export default Connect;